import { type ReactNode } from 'react'
import { type IntlShape } from 'react-intl'

export const shippingAccessorGetFormattedShippingLeadTime = (
  intl: IntlShape,
  deliveryTime?: {
    earliestDays?: number
    latestDays?: number
  },
): ReactNode => {
  if (
    !deliveryTime ||
    (typeof deliveryTime.earliestDays !== 'number' &&
      typeof deliveryTime.latestDays !== 'number')
  ) {
    return intl.formatMessage({ id: 'general.label.product.available' })
  }

  const { earliestDays, latestDays } = deliveryTime

  if (
    typeof earliestDays !== 'number' ||
    typeof latestDays !== 'number' ||
    earliestDays === latestDays
  ) {
    const oneDayDelivery = earliestDays ?? latestDays ?? 0

    return intl.formatMessage(
      { id: 'buyBox.delivery.daysCount' },
      { count: oneDayDelivery },
    )
  }

  return intl.formatMessage(
    {
      id: 'buyBox.delivery.daysCount',
    },
    {
      count: `${earliestDays}-${latestDays}`,
    },
  )
}
